import React from 'react';

import { Tabs, TabList, Tab, Box, Flex, Divider } from '@chakra-ui/react';

import { useColors } from './colors';

const TabNavigation = ({ currentTab, onTabChange, isEbay = false }) => {
  const {
    activeBgColor,
    inactiveBgColor,
    activeTextColor,
    inactiveTextColor,
    hoverInactiveBgColor,
    dividerColor,
  } = useColors();

  const tabs = isEbay
    ? ['Configuration', 'Sourcing Rules', 'Store Policies', 'Store Details']
    : ['Configuration', 'Sourcing Rules', 'Store Details'];

  return (
    <Flex justify="center" mb={6}>
      <Tabs index={currentTab} onChange={onTabChange} variant="unstyled">
        <TabList gap={8} alignItems="center">
          {tabs.map((tab, index) => {
            const isActive = currentTab === index;
            return (
              <React.Fragment key={tab}>
                {index > 0 && (
                  <Box height="24px">
                    <Divider
                      orientation="vertical"
                      borderColor={dividerColor}
                      borderLeftWidth="2px"
                    />
                  </Box>
                )}
                <Tab
                  py={3}
                  px={8}
                  borderRadius="full"
                  bg={isActive ? activeBgColor : inactiveBgColor}
                  color={isActive ? activeTextColor : inactiveTextColor}
                  fontWeight="medium"
                  _hover={{
                    bg: isActive ? activeBgColor : hoverInactiveBgColor,
                  }}
                >
                  {tab}
                </Tab>
              </React.Fragment>
            );
          })}
        </TabList>
      </Tabs>
    </Flex>
  );
};

export default TabNavigation;
